/**
 * Controls who can unlock the inline file-upload UI and what triggers it.
 *
 * RULES — Each rule binds a set of trigger words to upload constraints.
 *   - rules: []      → upload UI is ALWAYS visible (no trigger needed)
 *   - rules: [...]   → typing any trigger in input shows the UI
 *
 * ACCESS — Who is allowed to use trigger-based unlock.
 *   - both lists empty → everyone allowed (trigger alone opens UI)
 *   - any item present → only matching users; others are ignored silently
 *
 * To add a new upload bucket later (e.g. documents), push another rule:
 *   { name: 'documents', triggers: ['+file', '+doc'], accept: '*\/*',
 *     maxFiles: 5, uploadCategory: 'documents' }
 *
 * The existing support-ticket flow does NOT consult this config — it stays
 * untouched and continues to open the upload UI on its own state machine.
 */
export const UPLOAD_ACCESS_CONFIG = {
  rules: [
    {
      name: 'images',
      triggers: ['+image', '+img', '+i'],
      accept: 'image/*',
      maxFiles: 3,
      uploadCategory: 'assistant_images',
    },
  ],

  access: {
    allowedDomains: ['kiln.com'],
    allowedEmails: [
      'developer@productalex.com',
      'developer@productalex.com',
      'developer2@productalex.com',
    ],
  },
};
